import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from './globals';
import { SuperScript } from 'app/models/super-script';

@Injectable({
    providedIn: 'root'
})
export class SuperScriptService {
    constructor(private http: HttpClient, private globals: Globals) { }

    getAll(): Observable<SuperScript[]> {
        return this.http.get<SuperScript[]>(`${this.globals.api_base_url}/super-scripts`);
    }

    // Create new super script
    create(superScript: SuperScript): Observable<SuperScript> {
        return this.http.post<SuperScript>(`${this.globals.api_base_url}/super-scripts`, superScript);
    }

    // Update super script
    update(superScript: SuperScript): Observable<SuperScript> {
        return this.http.put<SuperScript>(`${this.globals.api_base_url}/super-scripts/${superScript.id}`, superScript);
    }

}
